/**
 * In the long term this getting the quizType form appSync  will be deprecated
 * Until then it is used as a fallback when launchParams do not provide quizType
 */

import {QuizType} from '../lib/quizType'

// @ts-expect-error Typescript is not fully setup in this codebase and Redux types are not yet handled.
export function getAssignmentType(state): QuizType {
  if (state.context?.assignmentType) {
    return state.context.assignmentType
  }

  const quizValues = Object.values(state?.appSync?.quizzes || {})
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const quiz: any = quizValues[0] || null

  if (!quiz || !quiz['quizType']) {
    return QuizType.GradedQuiz
  }

  return quiz['quizType'] as QuizType
}
